export const acompanharReguaCobrancaSteps = [
  {
    target: '.stepEscolhaRegua',
    content: 'Nesse campo você pode selecionar a régua que deseja acompanhar.',
    disableBeacon: true,
  },
  {
    target: '.stepAposVencimento',
    content: 'Aqui você acompanha todas as cobranças que foram enviadas após o dia de vencimento da cobrança.',
    disableBeacon: true,
  },
  {
    target: '.stepAntesVencimento',
    content: 'Aqui você acompanha todas as cobranças que foram enviadas antes do dia de vencimento da cobrança.',
    disableBeacon: true,
  },
];
